import React from 'react';
import moment from 'jalali-moment';

import classNames from 'classnames';
import {toPersianQuality} from 'utilities/helper/toPersianQuality';
import Address from 'modules/buyer/list/components/card/components/address';
interface WantedPostCardProps {
  wrapperClassName?: string;
  title: string;
  icon: string;
  quality: string;
  createdAt: string;
  state: string | null;
  city: string | null;
}
const WantedPostCard = ({
  wrapperClassName,
  title,
  icon,
  quality,
  createdAt,
  city,
  state,
}: WantedPostCardProps) => {
  return (
    <div
      className={classNames(
        'p-3 w-full rounded-[10px] shadow-[0_2.4049079418182373px_9.61963176727295px_0px_rgba(0,0,0,0.1)]',
        wrapperClassName,
      )}
    >
      <div className="flex justify-between">
        <div>
          <span className="flex items-center">
            <i className={classNames(icon, 'text-gray-5')} />
            <b dir="rtl" className="text-black ps-1">
              {title}
            </b>
          </span>
        </div>
        <div>
          <small
            className={classNames(
              ' px-2 py-1 rounded-full whitespace-nowrap	text-sm',
              quality === 'class_1'
                ? ' bg-warning-1 text-warning-2'
                : quality === 'class_2'
                ? ' bg-natural-3 text-natural-4'
                : quality === 'class_3'
                ? 'bg-error-1 text-warning-2'
                : ' bg-Cyan-chat-6 text-green-grade',
            )}
          >
            درجه {toPersianQuality[quality].degree}
          </small>
        </div>
      </div>
      <div className="pt-5">
        <Address
          dateTime={moment(new Date(createdAt))
            .locale('fa')
            .format('YYYY/MM/DD')}
          title={`${state}${city ? ` , ${city}` : ''}`}
        />
      </div>
    </div>
  );
};

export default WantedPostCard;
